export default __webpack_public_path__ + "static/media/kakao.c62c6a19.svg";